export default "__VITE_ASSET__vwvhH_8h__"